import React, { useEffect, useState } from "react";
import Header from "./Header";
import Footer from "./Footer";
import CookieConsent from "./CookieConsent";
import lazyLoad from "@/lib/lazyLoad";

// Defer the chat widget until the main content is interactive (unblocks LCP/INP).
const ChatWidget = lazyLoad(() => import("./ChatWidget"), null);

export default function Layout({ children, transparentHeader = false }) {
  const [showChat, setShowChat] = useState(false);
  useEffect(() => {
    const ric = window.requestIdleCallback || ((cb) => setTimeout(cb, 2000));
    const cic = window.cancelIdleCallback || clearTimeout;
    const id = ric(() => setShowChat(true));
    return () => cic(id);
  }, []);
  return (
    <div className="min-h-screen flex flex-col bg-nj-bg">
      <Header />
      <main className={`flex-1 ${transparentHeader ? "" : "pt-16 md:pt-20"}`}>{children}</main>
      <Footer />
      <CookieConsent />
      {showChat && <ChatWidget />}
    </div>
  );
}
